import { render, staticRenderFns } from "./ExpandableReview.vue?vue&type=template&id=0c9f2f50&scoped=true"
import script from "./ExpandableReview.vue?vue&type=script&lang=js"
export * from "./ExpandableReview.vue?vue&type=script&lang=js"
import style0 from "./ExpandableReview.vue?vue&type=style&index=0&id=0c9f2f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f2f50",
  null
  
)

export default component.exports